(() => {
  if (document.documentElement.hasAttribute('data-yiri-reviews-ready')) return
  document.documentElement.setAttribute('data-yiri-reviews-ready', '')

  const shuffle = (items) => {
    for (let index = items.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1))
      ;[items[index], items[randomIndex]] = [items[randomIndex], items[index]]
    }
    return items
  }

  const prepareCarousel = (section) => {
    const carousel = section.querySelector('[data-review-carousel]')
    if (!carousel || carousel.dataset.reviewPrepared === 'true') return

    carousel.dataset.reviewPrepared = 'true'
    const cards = shuffle(Array.from(carousel.querySelectorAll(':scope > .yiri-customer-reviews__slide')))
    cards.forEach((card) => carousel.appendChild(card))

    let layoutFrame
    const refreshLayout = () => {
      cancelAnimationFrame(layoutFrame)
      layoutFrame = requestAnimationFrame(() => {
        section.querySelectorAll('[data-review-quote]').forEach((quote) => {
          const button = quote.closest('.yiri-customer-reviews__quote-wrap').querySelector('[data-review-expand]')
          if (button) button.hidden = quote.scrollHeight <= quote.clientHeight + 2
        })
        // Fonts and Read more can change card height after Flickity's first measurement.
        window.Flickityt4s?.data(carousel)?.resize()
      })
    }
    refreshLayout()
    document.fonts?.ready.then(refreshLayout)
    const layoutObserver = new ResizeObserver(refreshLayout)
    section.querySelectorAll('.yiri-customer-reviews__quote, .yiri-customer-reviews__footer').forEach((element) => layoutObserver.observe(element))
    ;(section.closest('.shopify-section') || section).addEventListener('shopify:section:unload', () => {
      layoutObserver.disconnect()
      cancelAnimationFrame(layoutFrame)
    }, { once: true })
  }

  const prepareAll = (root = document) => {
    root.querySelectorAll('.yiri-customer-reviews').forEach(prepareCarousel)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareAll(), { once: true })
  } else {
    prepareAll()
  }

  document.addEventListener('shopify:section:load', (event) => prepareAll(event.target))

  document.addEventListener('click', (event) => {
    const imageTrigger = event.target.closest('[data-review-lightbox-trigger]')
    const imageClose = event.target.closest('[data-review-lightbox-close]')
    const reviewTrigger = event.target.closest('[data-review-expand]')
    const reviewClose = event.target.closest('[data-review-dialog-close]')

    if (imageTrigger) {
      const section = imageTrigger.closest('.yiri-customer-reviews')
      const dialog = section.querySelector('[data-review-lightbox]')
      const image = dialog.querySelector('[data-review-lightbox-image]')
      image.src = imageTrigger.dataset.reviewImage
      image.alt = imageTrigger.dataset.reviewAlt
      dialog.showModal()
    }

    if (imageClose) imageClose.closest('[data-review-lightbox]').close()

    if (reviewTrigger) {
      const section = reviewTrigger.closest('.yiri-customer-reviews')
      const dialog = section.querySelector('[data-review-dialog]')
      dialog.querySelector('[data-review-dialog-title]').textContent = reviewTrigger.dataset.reviewHeading
      dialog.querySelector('[data-review-dialog-body]').textContent = reviewTrigger.dataset.reviewContent
      dialog.showModal()
    }

    if (reviewClose) reviewClose.closest('[data-review-dialog]').close()

    if (event.target.matches('[data-review-lightbox], [data-review-dialog]')) event.target.close()
  })

  document.addEventListener('close', (event) => {
    if (!event.target.matches('[data-review-lightbox]')) return
    const image = event.target.querySelector('[data-review-lightbox-image]')
    image.removeAttribute('src')
    image.alt = ''
  }, true)
})()
